import { Collapse } from 'bootstrap'
import { gsap, Expo, Power1 } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

/**
* Initialize Hero Animations
**/
function initializeHeroAnimation() {
  const heroSection = document.querySelector('section.hero')
  const logoIconContainer = heroSection.querySelector('.logo-icon-container')
  const animationContainer = heroSection.querySelector('.animation-container')
  const blackBand = animationContainer.querySelector('.black-band')
  const imageContainer = animationContainer.querySelector('.image-container')
  const headlineContainer = animationContainer.querySelector('.headline-container')
  const tl = gsap.timeline()

  gsap.set(heroSection, {opacity: 1})

  tl.from(blackBand, {
    duration: 2.5,
    bottom: '100vh',
    ease: "power3"
  }, 0)

  tl.from(imageContainer, {
    duration: 2.5,
    top: '100vh',
    ease: "power3"
  }, 0)

  tl.from(logoIconContainer, {
    duration: 2,
    opacity: 0
  }, 1)

  tl.from(headlineContainer, {
    duration: 0.75,
    height: 0
  }, 0.5)

  tl.to(headlineContainer, {
    duration: 0,
    overflow: 'visible'
  }, 2)
}

/**
* Miscellaneous UI interactions
**/
function initializeUi() {
  /**
  * Footer disclaimer collapse
  **/
  let disclaimerToggle = document.querySelector('a[data-toggle="footerDisclaimer"]'),
      disclaimer = document.getElementById('footerDisclaimer'),
      disclaimerCollapse = new Collapse('#footerDisclaimer', {toggle: false})

  disclaimerToggle.addEventListener('click', (e) => {
    e.preventDefault()
    disclaimerCollapse.toggle()
  })

  disclaimer.addEventListener('shown.bs.collapse', (e) => {
    window.scrollTo(0, document.body.scrollHeight)
  })
}

const pageReady = () => {
  initializeUi()

  if ( document.body.classList.contains('home') ) {
    initializeHeroAnimation()
  }
}

if (
  document.readyState === 'complete'
  || (document.readyState !== 'loading' && !document.documentElement.doScroll)
) {
  pageReady()
} else {
  document.addEventListener('DOMContentLoaded', pageReady)
}